import { Box, Card, CardContent, Typography } from "@mui/material";
import { useState } from "react";
import styles from "./styles.module.scss";
import moment from "moment";
import { Highlight } from "types/highlights";

type Props = {
  highlight: Highlight;
};

export const HighlightsCard = ({ highlight }: Props) => {
  const [showMore, setShowMore] = useState(false);
  const publishDate = moment(highlight.publishedAt).format("MMMM DD, YYYY");
  if (!(highlight && highlight.text)) return <></>;
  return (
    <Card
      className="card"
      sx={{
        padding: { xs: "12px", lg: "1rem" },
        width: "100%",
      }}
      elevation={0}
    >
      <CardContent
        sx={{
          position: "relative",
          backgroundImage: `url(${highlight.image})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: { xs: "470px", lg: "510px" },
          display: "flex",
          alignItems: "flex-end",
          borderRadius: "6px",
        }}
      >
        <div
          className={
            showMore
              ? styles.highlight__overlay__more
              : styles.highlight__overlay
          }
        />
        <div className={styles.highlight__text}>
          <Typography variant="body1">
            {showMore ? highlight.text : `${highlight.text.substring(0, 150)}`}
            {highlight.text.length > 150 && (
              <Typography
                variant="body1"
                component={"span"}
                className={styles.highlight__more}
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? " Less" : " More"}
              </Typography>
            )}
          </Typography>
        </div>
      </CardContent>

      <Box className={styles.card__content}>
        <Typography variant="body2" className={styles.publish__date}>
          {publishDate}
        </Typography>
      </Box>
    </Card>
  );
};
